'use strict';

class EmailQueue {

    /**
     * @param {array} emails
     * @param {Moment} scheduleStartDateTime
     */
    constructor(emails, scheduleStartDateTime) {

        if (emails === undefined || scheduleStartDateTime === undefined) {
            throw new Error('emails and scheduleStartDateTime must be defined');
        }

        /**
         * @type {Email[]}
         * @private
         */
        this._emails = emails;

        /**
         * @type {number}
         * @private
         */
        this._pointer = emails.length - 1;

        /**
         * @type {Moment}
         * @private
         */
        this._scheduleStartDateTime = scheduleStartDateTime;

        /**
         * @type {number}
         * @private
         */
        this._unreadEmailCount = 0;

        /**
         * @type {number}
         * @private
         */
        this._emailDisplayCount = 0;

        this.markEmailsAlreadyReadyToDisplayAsRead();
    }

    /**
     * @return {Email[]}
     */
    get emails() {
        return this._emails;
    }

    /**
     * @return {number}
     */
    get unreadEmailCount() {
        return this._unreadEmailCount;
    }

    /**
     * @return {number}
     */
    get emailDisplayCount() {
        return this._emailDisplayCount;
    }

    /**
     * @param {Email} email
     */
    markEmailAsRead(email) {
        email.read = true;
        this.decrementUnreadEmailCount();
    }

    decrementUnreadEmailCount() {
        if (this._unreadEmailCount > 0) {
            this._unreadEmailCount--;
        }
    }

    markEmailsAlreadyReadyToDisplayAsRead() {
        let scheduleStartDateTime = this._scheduleStartDateTime;
        this._emails.forEach(function (email) {
            if (email.isReadyToDisplay(scheduleStartDateTime)) {
                email.read = true;
            }
        });
    }

    /**
     * @return {boolean}
     */
    update() {
        let currentEmail = this._emails[this._pointer];
        let areNewEmailsDisplayed = false;

        if (currentEmail !== undefined) {
            while (this.areThereAnyLeft() && currentEmail.isReadyToDisplay(this._scheduleStartDateTime)) {
                currentEmail.displayed = true;
                this._emailDisplayCount++;
                if (currentEmail.isUnread) {
                    areNewEmailsDisplayed = true;
                    this._unreadEmailCount++;
                }
                this._pointer--;
                currentEmail = this._emails[this._pointer];
            }
        }
        return areNewEmailsDisplayed;
    }

    /**
     * @returns {boolean}
     */
    areThereAnyLeft() {
        return (this._pointer !== -1);
    }
}

module.exports = EmailQueue;



// WEBPACK FOOTER //
// ./assets/vue/objects/EmailQueue.js